import React, { useState, useEffect } from 'react';
import { AuthContext, User } from './AuthContext';
import { IAuthProviderProps } from './types';
import { authService } from '../../services/api/authService';

export function AuthProvider({ children }: IAuthProviderProps) {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  const checkAuth = () => {
    authService.checkUserAuthentication()
      .then(response => {
        if (response.data && response.data.user) {
          setUser(response.data.user);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch(async () => {
        setIsAuthenticated(false);

        const returnUrl = encodeURIComponent(window.origin + window.location.pathname);
        window.location.href = `/api/v1/auth/login?returnUrl=${returnUrl}`;
      });
  };

  const setUserHandler = (newUser: User | null) => {
    setUser(newUser);
    if (newUser) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser: setUserHandler, isAuthenticated, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
